import { ref, computed, watch } from 'vue';
import { useComponentI18n } from '@rdrive/i18n';
import messages from './messages/index.js';

export default (props, { emit }) => {
    // LOCAL composer with the warn flags off (@rdrive/i18n): `photo` and `close` resolve here.
    const { t } = useComponentI18n(messages);

    // The open state, v-model'd through: the dialog's own close (scrim, Esc) and the Close button
    // both emit update:modelValue(false), as IssuesGrid's v-model on its own ref did.
    const open = computed({
        get: () => props.modelValue,
        set: (value) => emit('update:modelValue', value)
    });

    // The carousel's position: back to the first photo whenever the dialog opens. A 'pre' watcher
    // runs before this component re-renders, so the dialog opens on photo 1 in the same render as
    // before (IssuesGrid set its index to 0 in the opener, beside the photos and the open flag).
    const currentPhotoIndex = ref(0);
    watch(() => props.modelValue, (isOpen) => {
        if (isOpen) currentPhotoIndex.value = 0;
    });

    return {
        t,
        open,
        currentPhotoIndex
    };
};
